import { render, staticRenderFns } from "./LogMaterialTable.vue?vue&type=template&id=35f455c7"
import script from "./LogMaterialTable.vue?vue&type=script&lang=js"
export * from "./LogMaterialTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports